import {
  DEFAULT_DATE_MASK,
  DEFAULT_SEPARATOR,
  DEFAULT_TIMEZONE,
} from 'shared/mui/DatePicker/config/defaultValues';
import { formatInputInTz } from 'utils/date';

import { getPlaceholder } from './getPlaceholder';

type OptionsType = { format?: string; timezone?: string | null };

export function formatRangeInputToPlaceholder(
  range: [unknown, unknown],
  { timezone = DEFAULT_TIMEZONE, format = DEFAULT_DATE_MASK }: OptionsType = {},
): string {
  const [start, end] = range;

  const formatValue = (value: unknown) =>
    formatInputInTz(value, { timezone, format, placeholder: getPlaceholder(format) });

  return `${formatValue(start)}${DEFAULT_SEPARATOR}${formatValue(end)}`;
}
